/**
 * Модальное окно для правил, настроек, истории
 */

import * as PIXI from 'pixi.js';
import { TextStyle } from 'pixi.js';
import { Button } from './Button';
import { COLORS } from '@/config/colors';

export interface ModalOptions {
  width?: number;
  height?: number;
  title?: string;
  showCloseButton?: boolean;
}

export class Modal extends PIXI.Container {
  private background: PIXI.Graphics;
  private content: PIXI.Container;
  private titleText: PIXI.Text | null = null;
  private closeButton: Button | null = null;
  private onCloseCallback?: () => void;

  constructor(options: ModalOptions = {}) {
    super();
    const width = options.width ?? 600;
    const height = options.height ?? 400;

    this.background = new PIXI.Graphics();
    this.background.beginFill(0x000000, 0.8);
    this.background.drawRect(0, 0, width, height);
    this.background.endFill();
    this.background.lineStyle(2, COLORS.purple, 1);
    this.background.drawRect(0, 0, width, height);
    this.addChild(this.background);

    this.content = new PIXI.Container();
    this.content.x = 20;
    this.content.y = 60;
    this.addChild(this.content);

    if (options.title) {
      this.titleText = new PIXI.Text(
        options.title,
        new TextStyle({
          fontFamily: '"Jost"',
          fontSize: 24,
          fill: COLORS.textPrimary,
          fontWeight: 'bold',
        })
      );
      this.titleText.anchor.set(0.5);
      this.titleText.x = width / 2;
      this.titleText.y = 30;
      this.addChild(this.titleText);
    }

    if (options.showCloseButton !== false) {
      this.closeButton = new Button({
        width: 40,
        height: 40,
        radius: 20,
        fillColor: COLORS.buttonSecondary,
        text: '×',
        fontSize: 24,
      });
      this.closeButton.x = width - 50;
      this.closeButton.y = 10;
      this.closeButton.on('pointerdown', () => this.close());
      this.addChild(this.closeButton);
    }
  }

  getContent(): PIXI.Container {
    return this.content;
  }

  setTitle(title: string): void {
    if (this.titleText) {
      this.titleText.text = title;
    }
  }

  close(): void {
    this.visible = false;
    this.onCloseCallback?.();
  }

  show(): void {
    this.visible = true;
  }

  setOnClose(callback: () => void): void {
    this.onCloseCallback = callback;
  }
}
